<template>
    <footer class="main-footer">
        <div class="footer-links">
            <!-- <a href="/gas/lp08" class="footer-link">給湯器おすすめ業者ランキング</a> -->
            <a href="/InformationPage" class="footer-link">運用者情報</a>
            <a href="/privacy-policy" class="footer-link">プライバシーポリシー</a>
        </div>
        <div class="footer-copyright">
            <p>&copy; kyutouki-osusume.com All Rights Reserved.</p>
        </div>
    </footer>
</template>

<style scoped>
.main-footer {
    background-color: #3f51b5;  
    color: white;
    padding: 30px 20px;
    text-align: center;
    margin-top: auto;
}

.footer-links {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap; 
    gap: 20px; 
    margin-bottom: 20px;
}

.footer-link {
    color: white;
    text-decoration: none;
    font-size: 14px;
    font-weight: bold;
    transition: opacity 0.3s;
}

.footer-link:hover {
    opacity: 0.8;
}

.footer-copyright {
    border-top: 1px solid rgba(255, 255, 255, 0.3);
    padding-top: 20px;
}

.footer-copyright p {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

/* === スマホ調整 === */
@media (max-width: 600px) {
    .footer-links a{
        font-size: 0.8rem;
    }

    .footer-copyright p{
        font-size: 0.7rem;
    }
}
</style>